import { gql } from '@apollo/client';

// Fragments
const VariableItem = gql`
    fragment VariableItem on VariableProduct {
        name
        image {
            altText
            mediaItemUrl
        }
        galleryImages(first: 1) {
            nodes {
                mediaItemUrl
            }
        }
        link
        slug
        productCategories(first: 1) {
            edges {
                node {
                    id,
                    name
                }
            }
        }
        id
        name
        variations(first: 1) {
            nodes {
                databaseId
                name
                onSale
                price
                regularPrice
                stockStatus
                attributes {
                    nodes {
                        label
                        name
                        value
                    }
                }
            }
        }
    }
`;

const Cart = gql`
    fragment Cart on Cart {
        total
        totalTax
        subtotal
        contents {
            itemCount
            nodes {
                product {
                    node {
                        databaseId
                        image {
                            mediaItemUrl
                        }
                        name
                    }
                }
                key
                quantity
                variation {
                    node {
                        databaseId
                        price
                        attributes {
                            nodes {
                                value
                            }
                        }
                    }
                }
            }
        }
    }
`

const CustomContent = gql`
    fragment CustomContent on Page {
        pageTitle: title
        acfContent {
            pagecustom {
                blocktype
                bannerfullwidth {
                    title
                    subtitle
                    ctatext
                    href {
                        url
                    }
                    image {
                        mediaItemUrl
                        altText
                    }
                    imageDesktop {
                        mediaItemUrl
                        altText
                        mediaDetails {
                            width
                            height
                        }
                    }
                }
                sectiontitle {
                    title
                    subtitle
                }
                simpletext
                productlist {
                    category {
                        name
                        count
                        databaseId
                    }
                }
                categorylist {
                    backgroundImage {
                        mediaItemUrl
                        altText
                    }
                    ctaText
                    fieldGroupName
                    fullWidth
                    title
                    href {
                        url
                    }
                }
            }
        }
    }
`

export const Fragments = {
    Products: {
        VariableItem,
    },
    Page: {
        CustomContent
    },
    Cart: {
        Cart
    }
};

// Queries
export const GET_SINGLE_PRODUCT = gql`
  query SingleProduct($slug: ID!, $relatedProducts: Int! = 4) {
    product(id: $slug, idType: SLUG) {
      databaseId
      name
      description
      image {
        altText
        mediaItemUrl
      }
      galleryImages {
        nodes {
          mediaItemUrl
        }
      }
      productCategories {
        edges {
          node {
            name
            uri
          }
        }
      }
      wfSizeGuide {
        size
        length
        chest
        sleeve
        waist
      }
      ... on VariableProduct {
        id
        name
        variations {
          nodes {
            databaseId
            name
            onSale
            price
            regularPrice
            stockStatus
            attributes {
              nodes {
                label
                name
                value
              }
            }
          }
        }
      }
    }
    relatedProducts: products(
      where: { status: "publish", category: "news", orderby: { field: DATE, order: DESC } }
      first: $relatedProducts
    ) {
      nodes {
        databaseId
        name
        image {
          altText
          mediaItemUrl
        }
        galleryImages {
          nodes {
            mediaItemUrl
          }
        }
        link
        slug
        productCategories(first: 1) {
          edges {
            node {
              id
              name
            }
          }
        }
        ... on VariableProduct {
          id
          name
          variations(first: 1) {
            nodes {
              databaseId
              name
              onSale
              price
              regularPrice
              stockStatus
              attributes {
                nodes {
                  label
                  name
                  value
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_PRODUCTS = gql`
    query GetProducts($first: Int! = 12, $after: String, $category: String, $search: String) {
        products(where: {
            status: "publish",
            category: $category,
            search: $search,
            orderby: {
                field: MENU_ORDER,
                order: ASC
            }
        },
            first: $first,
            after: $after
        ),
        {
            productCount(slug: $category)
            edges {
                cursor
            }
            nodes {
                ...VariableItem
            }
        }
    }
    ${Fragments.Products.VariableItem}
`


export const GET_CUSTOMIZE_OPTIONS = gql`
    query CustomizePage {
        customizePage {
            wfCustomize {
              expressText
            }
        }
    }
`;

// Mutations
export const GET_PAGE_CONTENT = gql`
    query GetContent($slug: ID!) {
        page(id: $slug, idType: URI) {
            ...CustomContent
        }
    }
    ${Fragments.Page.CustomContent}
`

export const GET_CART = gql`
    query GetCart {
        cart {
            ...Cart
        }
    }
    ${Fragments.Cart.Cart}
`

export const ADD_TO_CART = gql`
    mutation AddToCart($productID: Int!, $variationID: Int) {
        addToCart(
            input: {
                productId: $productID,
                variationId: $variationID
            }
        ) {
            cart {
                ...Cart
            }
        }
    }
    ${Fragments.Cart.Cart}
`

export const EMPTY_CART = gql`
    mutation EmptyCart {
        emptyCart(input: {
            clearPersistentCart: true
        }) {
            clientMutationId
        }
    }
`

export const UPDATE_ITEM_QTY = gql`
    mutation UpdateItemQty($key: ID!, $qty: Int!) {
        updateItemQuantities(input: {
            items: {
                key: $key,
                quantity: $qty
            }
        }) {
            cart {
                ...Cart
            }
        }
    }
    ${Fragments.Cart.Cart}
`